export const SLICE_NAME = 'timeOffs';
